import Vault from "@components/Vault";
import PageLayout from "@components/PageLayout";
import { AirdropVaultProvider } from "@providers/AirdropVaultProvider";
import { fetchStrapiData } from "@services/strapi";

export const getStaticProps = async () => {
  const res = await fetchStrapiData("strategy-allocations");
  return {
    props: {
      page: {
        data: {
          cmsAllocations: (() => {
            if (res?.data?.length > 0) {
              const vaultData = res.data.find(
                (data: any) => data?.attributes?.vault_name === "airdrop_vault"
              );

              return vaultData?.attributes || [];
            }
            return [];
          })(),
        },
      },
    },
  };
};

const ValutPage = (props: { page: any }) => {
  return (
    <PageLayout extraMarginTop={false}>
      <AirdropVaultProvider
        data={{ cmsAllocations: props.page.data.cmsAllocations }}
      >
        <Vault />
      </AirdropVaultProvider>
    </PageLayout>
  );
};

export default ValutPage;
